// HelpFeedback.js
import React, { useState } from 'react';

const HelpFeedback = ({ hasTopButton }) => {
 const [showModal, setShowModal] = useState(false);

 return (
   <div className="help-feedback">
     <button
       className="help-button"
       onClick={() => setShowModal(true)}
       style={{
         position: 'absolute',
         top: '16px',
         right: '16px',
         backgroundColor: '#fff',
         color: '#8B5FBF',
         padding: '8px 16px',
         borderRadius: '8px',
         fontSize: '0.9rem',
         fontWeight: '600',
         transition: 'all 0.3s ease',
         border: '2px solid #8B5FBF',
         cursor: 'pointer',
         zIndex: 1100
       }}
       onMouseEnter={(e) => {
         e.target.style.backgroundColor = '#8B5FBF';
         e.target.style.color = '#fff';
       }}
       onMouseLeave={(e) => {
         e.target.style.backgroundColor = '#fff';
         e.target.style.color = '#8B5FBF';
       }}
     >
       Help / Feedback
     </button>
     {showModal && (
       <div className="modal-overlay">
         <div 
           className="modal-content"
           style={{
             marginTop: hasTopButton ? '60px' : '20px'
           }}
         >
           <p>
             If you need help or have any feedback for us, please email{' '}
             <a href="mailto:info@okgather.com">info@okgather.com</a> and we will aim to get back to you really quickly!
           </p>
           <button onClick={() => setShowModal(false)}>Close</button>
         </div>
       </div>
     )}
   </div>
 );
};

export default HelpFeedback;